import Integration20 from '@carbon/icons-react/es/integration/20';
import { Col, Row } from 'antd';
import React, { FC } from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { CardLink } from 'components/molecules/card-link';
import { Page } from 'components/molecules/page';
import { HeaderWithIconTitle } from 'components/molecules/page/page';
import { useTranslation } from 'hooks/use-translation';
import { IntegrationCardDetails } from './integrations-list/config';

const PageContent = styled(Page.Content)`
  padding: var(--layout-03);

  > .ant-row {
    padding: var(--spacing-03);
  }
`;

export const Integrations: FC = () => {
  const title = useTranslation('integrations');
  const integrationList = IntegrationCardDetails();

  return (
    <Page>
      <Page.Header
        $white
        title={<HeaderWithIconTitle icon={<Integration20 />} title={title} />}
      />
      <PageContent>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <Row gutter={[32, 32]}>
          {integrationList
            .filter((integration) => integration.enabled)
            .map((integration) => (
              <Col xl={8} lg={8}>
                <CardLink {...integration} hoverable />
              </Col>
            ))}
        </Row>
      </PageContent>
    </Page>
  );
};
